

import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import Banner from '../components/banners/Banner';
import SmartSpecs from '../components/SmartSpecs';
import SmartTech from '../components/SmartTech';
import ItlSpecs from '../components/ItlSpecs';
import ItlTech from '../components/ItlTech';
import IRDSSpecs from '../components/IRDSSpecs';
import Footer from '../components/Footer';

const Product = () => {
  const searchParams = new URLSearchParams(useLocation().search);
  const type = searchParams.get('type'); 

  const [model, setModel] = useState(type || "smart");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [model]);

  return (
    <div>
      <Banner model={model} setModel={setModel} />                  

      {model === "smart" && <>
        <SmartSpecs />
        <SmartTech />
      </>}                                   

      {model === "itl" && <>
        <ItlSpecs />
        <ItlTech />
      </>}

      {model === "irds" && <IRDSSpecs />}

      <Footer />
    </div>
  );
};

export default Product;